import { useVahakMutationQuery } from "../hooks/useVahakQueryClient";
import useVahakHttpClient from "../hooks/useVahakHttpClient";
import API from "./const";
import { QueryNames } from "./hooks/queryNames";

export enum HelpRequestScreen {
    CONTACT_US = "Contact Us Page (Web)",
    SUPPORT_ICON = "Support Floating Icon (Web)",
    LOAD_BID = "Load Bid Form (Web)",
    LORRY_BID = "Lorry Bid Form (Web)",
    COMPANY_REGISTER = "Company Register (Web)"
}

interface RequestParams {
    company_id: number;
    issue: string;
    source_screen: string;
    topic: string;
}

export interface ResponseData {
    data: {
        ticket_id: string;
        message: string;
    };
}

export const useHelpRequestTicket = () => {
    const { POST } = useVahakHttpClient();
    function method(data: RequestParams) {
        return POST<RequestParams, ResponseData>(API.TICKET_HELP_REQUEST, { ...data });
    }

    return useVahakMutationQuery<ResponseData, unknown, RequestParams>(QueryNames.helpRequest, method);
};
